import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { BRAND, HERO_IMAGE } from "@/lib/data";

const EASE = [0.76, 0, 0.24, 1];

const Line = ({ children, delay }) => (
  <span className="reveal-mask">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero" className="relative min-h-screen w-full overflow-hidden">
      {/* Parallax backdrop */}
      <motion.div
        className="absolute inset-0"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: EASE }}
      >
        <img
          src={HERO_IMAGE}
          alt="A volunteer sharing a meal with someone on the street"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/65" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/70" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 min-h-screen flex flex-col justify-end pb-16 md:pb-24">
        <motion.p
          className="label mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Street Outreach · Homeless Relief
        </motion.p>

        <h1 className="font-display uppercase leading-[0.85] tracking-tight text-white text-[19vw] md:text-[13vw] lg:text-[11vw]">
          <Line delay={0.15}>Mask</Line>
          <Line delay={0.28}>
            <span className="text-green glow-green">Giver</span>
          </Line>
        </h1>

        <div className="mt-8 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <Line delay={0.5}>
            <p className="font-sub text-xl md:text-3xl text-zinc-200 max-w-xl">
              {BRAND.mission}.
            </p>
          </Line>

          <motion.div
            className="flex items-center gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.85, duration: 0.8 }}
          >
            <button
              data-testid="hero-donate-btn"
              onClick={() => go("#donate")}
              className="btn-fill border border-green text-green font-sub font-semibold px-8 py-3.5 rounded-full box-glow"
            >
              Give now
            </button>
            <button
              data-testid="hero-story-btn"
              onClick={() => go("#mission")}
              className="font-sub text-white/80 hover:text-white flex items-center gap-2 link-underline"
            >
              Our story
            </button>
          </motion.div>
        </div>
      </div>

      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/50"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
      >
        <ArrowDown size={22} />
      </motion.div>
    </section>
  );
};
